import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import "./Footer.scss";
import { Link } from "react-router-dom";

function Footer(props) {
  const location = useLocation();
  const [facebookIconHovered, setFacebookIconHovered] = useState(false);
  const [instagramIconHovered, setInstagramIconHovered] = useState(false);
  const [twitterIconHovered, setTwitterIconHovered] = useState(false);
  const [linkedinIconHovered, setLinkedInIconHovered] = useState(false);
  return (
    <>
      {![
        "/signup",
        "/login",
        "/404",
        "/forgot-password",
        "/reset-password",
        "/dashboard",
        "/dashboard/study",
        "/dashboard/friends",
        "/thanks-for-purchase",
      ].includes(location.pathname) &&
        location.pathname.indexOf("/recall") === -1 && (
          <footer
            className="quizzy-footer"
            style={{
              marginTop: location.pathname === "/" ? 0 : "120px",
            }}
          >
            <div className="cover">
              <div className="divider">
                <div className="main-container">
                  <div className="quizzy-logo">
                    <Link to="https://quizzynow.com/">Quizzy</Link>
                  </div>
                  <p className="company-desc">
                    Quizzy is a web-app rooted in the belief that AI and
                    cooperative studying can be used to bolster students' grades
                    and material retention more effectively than traditional
                    study methods.{" "}
                  </p>
                  <div className="socials">
                    <a
                      href="https://twitter.com/quizzynow"
                      alt="quizzy twitter"
                    >
                      <img
                        src={
                          twitterIconHovered
                            ? "/images/footer/hovered/icons8-twitter.svg"
                            : "/images/footer/icons8-twitter.svg"
                        }
                        alt="Twitter Icon"
                        onMouseEnter={() => {
                          setTwitterIconHovered(true);
                        }}
                        onMouseLeave={() => {
                          setTwitterIconHovered(false);
                        }}
                      ></img>
                    </a>
                    {/*
                    <a href="https://facebook.com/">
                      <img
                        src={
                          facebookIconHovered
                            ? "/images/footer/hovered/icons8-facebook.svg"
                            : "/images/footer/icons8-facebook.svg"
                        }
                        alt="Facebook"
                        onMouseEnter={() => {
                          setFacebookIconHovered(true);
                        }}
                        onMouseLeave={() => {
                          setFacebookIconHovered(false);
                        }}></img>
                    </a>*/}

                    <a href="https://www.instagram.com/quizzynow/">
                      <img
                        src={
                          instagramIconHovered
                            ? "/images/footer/hovered/icons8-instagram.svg"
                            : "/images/footer/icons8-instagram.svg"
                        }
                        alt="Instagram"
                        onMouseEnter={() => {
                          setInstagramIconHovered(true);
                        }}
                        onMouseLeave={() => {
                          setInstagramIconHovered(false);
                        }}
                      ></img>
                    </a>
                    {/*<a href="https://linkedin.com"><img src={linkedinIconHovered ? "/images/footer/hovered/icons8-linkedin-circled.svg" : "/images/footer/icons8-linkedin-circled.svg"} alt="LinkedIn" onMouseEnter={() => {
                                setLinkedInIconHovered(true);
                            }} onMouseLeave={() => {
                                setLinkedInIconHovered(false);
                            }}></img></a>*/}
                  </div>
                </div>
                <div className="hrefs">
                  <div className="upgrade">
                    <p>Upgrade</p>
                    <Link to="/upgrade">Quizzy+</Link>
                  </div>
                  <div className="product">
                    <p>Product</p>
                    <Link to="https://quizzynow.com/support/sections/flashcards">
                      Flashcards
                    </Link>
                    <Link to="https://quizzynow.com/support/sections/recall-sessions">
                      Recall Sessions
                    </Link>
                  </div>
                  <div className="company">
                    <p>Company</p>
                    <Link to="https://quizzynow.com/about-us">About Us</Link>
                    <Link to="https://quizzynow.com/blog">Blog</Link>
                    {/*<a href="/faq">FAQ</a>*/}
                    {/*<Link to="https://quizzynow.com/jobs">Jobs</Link>*/}
                  </div>
                  <div className="policies">
                    <p>Policies</p>
                    <Link to="https://quizzynow.com/support/sections/getting-started/9/quizzy-terms-of-service-04-07-2023">
                      Terms
                    </Link>
                    <Link to="https://quizzynow.com/support/sections/getting-started/10/quizzy-privacy-policy-04-07-2023">
                      Privacy
                    </Link>
                    <a onClick={() => props.setBannerVisibility(true)}>
                      Cookies
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
    </>
  );
}

export default Footer;
